export default response => {
    return {
        pageSize: response.headers['pagination-page-size'],
        page: response.headers['pagination-current-page'],
        totalItems: response.headers['pagination-total-items'],
        totalPages: response.headers['pagination-total-pages'],
        lastPage: response.headers['pagination-last-page']
    };
};
